<component :is="tag" type="button" @click="openDialog" v-if="authorized &amp;&amp; configured"><slot>Google Drive</slot></component>